import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { AdvancedSearchRedux } from '../Redux/AdvancedSearchRedux'

const AdvancedSearchCRUDObservable = createCRUDObservable({
  mainRedux: AdvancedSearchRedux,
  reduxPath: 'advanced_search',
  dataHandlers: {
    get: response => response.data,
  },
})
export const AdvancedSearchObservers = Object.assign({}, AdvancedSearchCRUDObservable.observers, {})
export const AdvancedSearchEpic = combineEpics(
  AdvancedSearchCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/AdvancedSearchObservable.js